import { render, staticRenderFns } from "./MyTicket.vue?vue&type=template&id=a1b95fd0&scoped=true&"
import script from "./MyTicket.vue?vue&type=script&lang=js&"
export * from "./MyTicket.vue?vue&type=script&lang=js&"
import style0 from "./MyTicket.vue?vue&type=style&index=0&id=a1b95fd0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b95fd0",
  null
  
)

export default component.exports